import { Action } from 'common/interfaces/root';
import { asinRecommendationActionTypes as TYPES } from '../actions/action-types';

const initialState: AsinRecommendationModule.State.ExportState = {
  loading: false,
  data: null,
  error: null,
};

export default (
  state: AsinRecommendationModule.State.ExportState = initialState,
  { type, payload }: Action
): AsinRecommendationModule.State.ExportState => {
  switch (type) {
    case TYPES.EXPORT.GET_EXPORT:
      return { ...state, loading: true };
    case TYPES.EXPORT.GET_EXPORT_SUCCESS:
      return { ...state, loading: false, data: payload };
    case TYPES.EXPORT.GET_EXPORT_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
